import * as Le from "react";
import Ne, { useState as J, useContext as Rr, useRef as ze, cloneElement as jr, useEffect as K, isValidElement as Cr } from "react";
import { Modal as M, Form as A, Button as ie } from "react-bootstrap";
import { useTranslation as Me } from "react-i18next";
import Tr from "react-dom";
function Sr(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
var se = { exports: {} }, Z = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ke;
function Or() {
  if (ke)
    return Z;
  ke = 1;
  var a = Ne, h = Symbol.for("react.element"), f = Symbol.for("react.fragment"), c = Object.prototype.hasOwnProperty, g = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function E(_, n, p) {
    var d, y = {}, v = null, C = null;
    p !== void 0 && (v = "" + p), n.key !== void 0 && (v = "" + n.key), n.ref !== void 0 && (C = n.ref);
    for (d in n)
      c.call(n, d) && !s.hasOwnProperty(d) && (y[d] = n[d]);
    if (_ && _.defaultProps)
      for (d in n = _.defaultProps, n)
        y[d] === void 0 && (y[d] = n[d]);
    return { $$typeof: h, type: _, key: v, ref: C, props: y, _owner: g.current };
  }
  return Z.Fragment = f, Z.jsx = E, Z.jsxs = E, Z;
}
var Y = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var De;
function Ar() {
  return De || (De = 1, process.env.NODE_ENV !== "production" && function() {
    var a = Ne, h = Symbol.for("react.element"), f = Symbol.for("react.portal"), c = Symbol.for("react.fragment"), g = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), E = Symbol.for("react.provider"), _ = Symbol.for("react.context"), n = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), C = Symbol.for("react.offscreen"), k = Symbol.iterator, U = "@@iterator";
    function L(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = k && e[k] || e[U];
      return typeof r == "function" ? r : null;
    }
    var D = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
          t[i - 1] = arguments[i];
        qe("error", e, t);
      }
    }
    function qe(e, r, t) {
      {
        var i = D.ReactDebugCurrentFrame, m = i.getStackAddendum();
        m !== "" && (r += "%s", t = t.concat([m]));
        var b = t.map(function(u) {
          return String(u);
        });
        b.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, b);
      }
    }
    var Be = !1, Ve = !1, Ge = !1, He = !1, Je = !1, ce;
    ce = Symbol.for("react.module.reference");
    function Ke(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === c || e === s || Je || e === g || e === p || e === d || He || e === C || Be || Ve || Ge || typeof e == "object" && e !== null && (e.$$typeof === v || e.$$typeof === y || e.$$typeof === E || e.$$typeof === _ || e.$$typeof === n || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === ce || e.getModuleId !== void 0));
    }
    function Xe(e, r, t) {
      var i = e.displayName;
      if (i)
        return i;
      var m = r.displayName || r.name || "";
      return m !== "" ? t + "(" + m + ")" : t;
    }
    function ue(e) {
      return e.displayName || "Context";
    }
    function S(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case c:
          return "Fragment";
        case f:
          return "Portal";
        case s:
          return "Profiler";
        case g:
          return "StrictMode";
        case p:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case _:
            var r = e;
            return ue(r) + ".Consumer";
          case E:
            var t = e;
            return ue(t._context) + ".Provider";
          case n:
            return Xe(e, e.render, "ForwardRef");
          case y:
            var i = e.displayName || null;
            return i !== null ? i : S(e.type) || "Memo";
          case v: {
            var m = e, b = m._payload, u = m._init;
            try {
              return S(u(b));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var F = Object.assign, N = 0, de, fe, me, he, pe, ve, be;
    function ge() {
    }
    ge.__reactDisabledLog = !0;
    function Qe() {
      {
        if (N === 0) {
          de = console.log, fe = console.info, me = console.warn, he = console.error, pe = console.group, ve = console.groupCollapsed, be = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ge,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        N++;
      }
    }
    function er() {
      {
        if (N--, N === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: F({}, e, {
              value: de
            }),
            info: F({}, e, {
              value: fe
            }),
            warn: F({}, e, {
              value: me
            }),
            error: F({}, e, {
              value: he
            }),
            group: F({}, e, {
              value: pe
            }),
            groupCollapsed: F({}, e, {
              value: ve
            }),
            groupEnd: F({}, e, {
              value: be
            })
          });
        }
        N < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var X = D.ReactCurrentDispatcher, Q;
    function W(e, r, t) {
      {
        if (Q === void 0)
          try {
            throw Error();
          } catch (m) {
            var i = m.stack.trim().match(/\n( *(at )?)/);
            Q = i && i[1] || "";
          }
        return `
` + Q + e;
      }
    }
    var ee = !1, q;
    {
      var rr = typeof WeakMap == "function" ? WeakMap : Map;
      q = new rr();
    }
    function _e(e, r) {
      if (!e || ee)
        return "";
      {
        var t = q.get(e);
        if (t !== void 0)
          return t;
      }
      var i;
      ee = !0;
      var m = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var b;
      b = X.current, X.current = null, Qe();
      try {
        if (r) {
          var u = function() {
            throw Error();
          };
          if (Object.defineProperty(u.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(u, []);
            } catch (O) {
              i = O;
            }
            Reflect.construct(e, [], u);
          } else {
            try {
              u.call();
            } catch (O) {
              i = O;
            }
            e.call(u.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (O) {
            i = O;
          }
          e();
        }
      } catch (O) {
        if (O && i && typeof O.stack == "string") {
          for (var l = O.stack.split(`
`), j = i.stack.split(`
`), w = l.length - 1, x = j.length - 1; w >= 1 && x >= 0 && l[w] !== j[x]; )
            x--;
          for (; w >= 1 && x >= 0; w--, x--)
            if (l[w] !== j[x]) {
              if (w !== 1 || x !== 1)
                do
                  if (w--, x--, x < 0 || l[w] !== j[x]) {
                    var T = `
` + l[w].replace(" at new ", " at ");
                    return e.displayName && T.includes("<anonymous>") && (T = T.replace("<anonymous>", e.displayName)), typeof e == "function" && q.set(e, T), T;
                  }
                while (w >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        ee = !1, X.current = b, er(), Error.prepareStackTrace = m;
      }
      var $ = e ? e.displayName || e.name : "", Fe = $ ? W($) : "";
      return typeof e == "function" && q.set(e, Fe), Fe;
    }
    function tr(e, r, t) {
      return _e(e, !1);
    }
    function nr(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function B(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return _e(e, nr(e));
      if (typeof e == "string")
        return W(e);
      switch (e) {
        case p:
          return W("Suspense");
        case d:
          return W("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case n:
            return tr(e.render);
          case y:
            return B(e.type, r, t);
          case v: {
            var i = e, m = i._payload, b = i._init;
            try {
              return B(b(m), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var V = Object.prototype.hasOwnProperty, ye = {}, Ee = D.ReactDebugCurrentFrame;
    function G(e) {
      if (e) {
        var r = e._owner, t = B(e.type, e._source, r ? r.type : null);
        Ee.setExtraStackFrame(t);
      } else
        Ee.setExtraStackFrame(null);
    }
    function ar(e, r, t, i, m) {
      {
        var b = Function.call.bind(V);
        for (var u in e)
          if (b(e, u)) {
            var l = void 0;
            try {
              if (typeof e[u] != "function") {
                var j = Error((i || "React class") + ": " + t + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw j.name = "Invariant Violation", j;
              }
              l = e[u](r, u, i, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (w) {
              l = w;
            }
            l && !(l instanceof Error) && (G(m), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", i || "React class", t, u, typeof l), G(null)), l instanceof Error && !(l.message in ye) && (ye[l.message] = !0, G(m), R("Failed %s type: %s", t, l.message), G(null));
          }
      }
    }
    var or = Array.isArray;
    function re(e) {
      return or(e);
    }
    function ir(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function sr(e) {
      try {
        return we(e), !1;
      } catch {
        return !0;
      }
    }
    function we(e) {
      return "" + e;
    }
    function xe(e) {
      if (sr(e))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ir(e)), we(e);
    }
    var z = D.ReactCurrentOwner, lr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Re, je, te;
    te = {};
    function cr(e) {
      if (V.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function ur(e) {
      if (V.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function dr(e, r) {
      if (typeof e.ref == "string" && z.current && r && z.current.stateNode !== r) {
        var t = S(z.current.type);
        te[t] || (R('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', S(z.current.type), e.ref), te[t] = !0);
      }
    }
    function fr(e, r) {
      {
        var t = function() {
          Re || (Re = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function mr(e, r) {
      {
        var t = function() {
          je || (je = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var hr = function(e, r, t, i, m, b, u) {
      var l = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: h,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: u,
        // Record the component responsible for creating this element.
        _owner: b
      };
      return l._store = {}, Object.defineProperty(l._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(l, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), Object.defineProperty(l, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.freeze && (Object.freeze(l.props), Object.freeze(l)), l;
    };
    function pr(e, r, t, i, m) {
      {
        var b, u = {}, l = null, j = null;
        t !== void 0 && (xe(t), l = "" + t), ur(r) && (xe(r.key), l = "" + r.key), cr(r) && (j = r.ref, dr(r, m));
        for (b in r)
          V.call(r, b) && !lr.hasOwnProperty(b) && (u[b] = r[b]);
        if (e && e.defaultProps) {
          var w = e.defaultProps;
          for (b in w)
            u[b] === void 0 && (u[b] = w[b]);
        }
        if (l || j) {
          var x = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          l && fr(u, x), j && mr(u, x);
        }
        return hr(e, l, j, m, i, z.current, u);
      }
    }
    var ne = D.ReactCurrentOwner, Ce = D.ReactDebugCurrentFrame;
    function I(e) {
      if (e) {
        var r = e._owner, t = B(e.type, e._source, r ? r.type : null);
        Ce.setExtraStackFrame(t);
      } else
        Ce.setExtraStackFrame(null);
    }
    var ae;
    ae = !1;
    function oe(e) {
      return typeof e == "object" && e !== null && e.$$typeof === h;
    }
    function Te() {
      {
        if (ne.current) {
          var e = S(ne.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function vr(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), t = e.lineNumber;
          return `

Check your code at ` + r + ":" + t + ".";
        }
        return "";
      }
    }
    var Se = {};
    function br(e) {
      {
        var r = Te();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function Oe(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = br(r);
        if (Se[t])
          return;
        Se[t] = !0;
        var i = "";
        e && e._owner && e._owner !== ne.current && (i = " It was passed a child from " + S(e._owner.type) + "."), I(e), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, i), I(null);
      }
    }
    function Ae(e, r) {
      {
        if (typeof e != "object")
          return;
        if (re(e))
          for (var t = 0; t < e.length; t++) {
            var i = e[t];
            oe(i) && Oe(i, r);
          }
        else if (oe(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var m = L(e);
          if (typeof m == "function" && m !== e.entries)
            for (var b = m.call(e), u; !(u = b.next()).done; )
              oe(u.value) && Oe(u.value, r);
        }
      }
    }
    function gr(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === n || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === y))
          t = r.propTypes;
        else
          return;
        if (t) {
          var i = S(r);
          ar(t, e.props, "prop", i, e);
        } else if (r.PropTypes !== void 0 && !ae) {
          ae = !0;
          var m = S(r);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", m || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function _r(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var i = r[t];
          if (i !== "children" && i !== "key") {
            I(e), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", i), I(null);
            break;
          }
        }
        e.ref !== null && (I(e), R("Invalid attribute `ref` supplied to `React.Fragment`."), I(null));
      }
    }
    function Pe(e, r, t, i, m, b) {
      {
        var u = Ke(e);
        if (!u) {
          var l = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (l += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var j = vr(m);
          j ? l += j : l += Te();
          var w;
          e === null ? w = "null" : re(e) ? w = "array" : e !== void 0 && e.$$typeof === h ? (w = "<" + (S(e.type) || "Unknown") + " />", l = " Did you accidentally export a JSX literal instead of a component?") : w = typeof e, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", w, l);
        }
        var x = pr(e, r, t, m, b);
        if (x == null)
          return x;
        if (u) {
          var T = r.children;
          if (T !== void 0)
            if (i)
              if (re(T)) {
                for (var $ = 0; $ < T.length; $++)
                  Ae(T[$], e);
                Object.freeze && Object.freeze(T);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ae(T, e);
        }
        return e === c ? _r(x) : gr(x), x;
      }
    }
    function yr(e, r, t) {
      return Pe(e, r, t, !0);
    }
    function Er(e, r, t) {
      return Pe(e, r, t, !1);
    }
    var wr = Er, xr = yr;
    Y.Fragment = c, Y.jsx = wr, Y.jsxs = xr;
  }()), Y;
}
process.env.NODE_ENV === "production" ? se.exports = Or() : se.exports = Ar();
var o = se.exports;
const Pr = ({ show: a, setShowState: h, onConfirm: f }) => {
  const [c, g] = J({
    value: "",
    isInvalid: !1,
    errorMsg: ""
  }), [s, E] = J({
    value: "",
    isInvalid: !1,
    errorMsg: ""
  }), { t: _ } = Me("plugin", {
    keyPrefix: "basic_embed.frontend"
  }), n = () => {
    h(!1);
  }, p = (v) => {
    g({
      value: v.target.value,
      isInvalid: !1,
      errorMsg: ""
    });
  }, d = (v) => {
    E({
      value: v.target.value,
      isInvalid: !1,
      errorMsg: ""
    });
  }, y = () => {
    if (!c.value) {
      g({
        ...c,
        isInvalid: !0,
        errorMsg: _("required_title")
      });
      return;
    }
    if (!s.value) {
      E({
        ...s,
        isInvalid: !0,
        errorMsg: _("required_url")
      });
      return;
    }
    if (!/^[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(s.value)) {
      E({
        ...s,
        isInvalid: !0,
        errorMsg: _("invalid_url")
      });
      return;
    }
    f({
      title: c.value,
      url: s.value
    }), h(!1), g({
      value: "",
      isInvalid: !1,
      errorMsg: ""
    }), E({
      value: "",
      isInvalid: !1,
      errorMsg: ""
    });
  };
  return /* @__PURE__ */ o.jsxs(M, { show: a, onHide: n, children: [
    /* @__PURE__ */ o.jsx(M.Header, { closeButton: !0, children: /* @__PURE__ */ o.jsx(M.Title, { children: _("header") }) }),
    /* @__PURE__ */ o.jsx(M.Body, { children: /* @__PURE__ */ o.jsxs(A, { children: [
      /* @__PURE__ */ o.jsxs(A.Group, { className: "mb-3", controlId: "editor.plugin.embed.title", children: [
        /* @__PURE__ */ o.jsx(A.Label, { children: _("title") }),
        /* @__PURE__ */ o.jsx(
          A.Control,
          {
            type: "text",
            value: c.value,
            isInvalid: c.isInvalid,
            onChange: p
          }
        ),
        /* @__PURE__ */ o.jsx(A.Control.Feedback, { type: "invalid", children: c.errorMsg })
      ] }),
      /* @__PURE__ */ o.jsxs(A.Group, { className: "mb-3", controlId: "editor.plugin.embed.url", children: [
        /* @__PURE__ */ o.jsx(A.Label, { children: _("url") }),
        /* @__PURE__ */ o.jsx(
          A.Control,
          {
            type: "url",
            value: s.value,
            isInvalid: s.isInvalid,
            onChange: d
          }
        ),
        /* @__PURE__ */ o.jsx(A.Control.Feedback, { type: "invalid", children: s.errorMsg })
      ] })
    ] }) }),
    /* @__PURE__ */ o.jsxs(M.Footer, { children: [
      /* @__PURE__ */ o.jsx(ie, { variant: "link", onClick: n, children: _("cancel") }),
      /* @__PURE__ */ o.jsx(ie, { variant: "primary", onClick: y, children: _("add") })
    ] })
  ] });
};
var le, H = Tr;
if (process.env.NODE_ENV === "production")
  le = H.createRoot, H.hydrateRoot;
else {
  var Ie = H.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  le = function(a, h) {
    Ie.usingClientEntryPoint = !0;
    try {
      return H.createRoot(a, h);
    } finally {
      Ie.usingClientEntryPoint = !1;
    }
  };
}
var Ze = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(a) {
  (function() {
    var h = {}.hasOwnProperty;
    function f() {
      for (var c = [], g = 0; g < arguments.length; g++) {
        var s = arguments[g];
        if (s) {
          var E = typeof s;
          if (E === "string" || E === "number")
            c.push(s);
          else if (Array.isArray(s)) {
            if (s.length) {
              var _ = f.apply(null, s);
              _ && c.push(_);
            }
          } else if (E === "object") {
            if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]")) {
              c.push(s.toString());
              continue;
            }
            for (var n in s)
              h.call(s, n) && s[n] && c.push(n);
          }
        }
      }
      return c.join(" ");
    }
    a.exports ? (f.default = f, a.exports = f) : window.classNames = f;
  })();
})(Ze);
var Fr = Ze.exports;
const kr = /* @__PURE__ */ Sr(Fr), Dr = ["xxl", "xl", "lg", "md", "sm", "xs"], Ir = "xs", $r = /* @__PURE__ */ Le.createContext({
  prefixes: {},
  breakpoints: Dr,
  minBreakpoint: Ir
});
function Lr(a, h) {
  const {
    prefixes: f
  } = Rr($r);
  return a || f[h] || h;
}
const Ye = /* @__PURE__ */ Le.forwardRef(({
  bsPrefix: a,
  variant: h,
  animation: f = "border",
  size: c,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: g = "div",
  className: s,
  ...E
}, _) => {
  a = Lr(a, "spinner");
  const n = `${a}-${f}`;
  return /* @__PURE__ */ o.jsx(g, {
    ref: _,
    ...E,
    className: kr(s, n, c && `${n}-${c}`, h && `text-${h}`)
  });
});
Ye.displayName = "Spinner";
const Ue = Ye, P = ({
  children: a,
  height: h = 350
}) => {
  const f = ze(null), c = () => {
    if (f.current) {
      const s = f.current.parentElement;
      s && (s.style.height = h + "px"), f.current.remove();
    }
  };
  let g = a;
  return a.type === "iframe" && (g = jr(a, { onLoad: c })), /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    g,
    /* @__PURE__ */ o.jsx(
      "span",
      {
        ref: f,
        className: "loading position-absolute top-0 left-0 w-100 h-100 z-1 bg-white d-flex justify-content-center align-items-center",
        children: /* @__PURE__ */ o.jsx(Ue, { animation: "border", variant: "secondary" })
      }
    )
  ] });
}, Nr = ({ scriptUrl: a }) => /* @__PURE__ */ o.jsx(P, { children: /* @__PURE__ */ o.jsx(
  "iframe",
  {
    className: "w-100 h-100",
    src: `data:text/html;charset=utf-8,<head><base target='_blank' /></head><body style='margin:0;'><script src='${a}'><\/script></body>`
  }
) }), zr = ({ penId: a }) => /* @__PURE__ */ o.jsx(P, { children: /* @__PURE__ */ o.jsx(
  "iframe",
  {
    width: "100%",
    height: "100%",
    src: `https://codepen.io/${a}/embed/preview/${a}?height=265&theme-id=0&default-tab=result`,
    title: "CodePen Embed",
    allowTransparency: !0,
    allowFullScreen: !0
  }
) }), Mr = ({ videoId: a }) => /* @__PURE__ */ o.jsx(P, { height: 380, children: /* @__PURE__ */ o.jsx(
  "iframe",
  {
    width: "100%",
    height: "100%",
    src: `https://www.youtube.com/embed/${a}`,
    title: "YouTube video player",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: !0
  }
) }), Zr = ({ fiddleId: a }) => /* @__PURE__ */ o.jsx(P, { children: /* @__PURE__ */ o.jsx(
  "iframe",
  {
    width: "100%",
    height: "100%",
    src: `https://jsfiddle.net/${a}/embedded/`,
    allowFullScreen: !0,
    allowTransparency: !0
  }
) }), Yr = ({ url: a }) => /* @__PURE__ */ o.jsx(P, { height: 450, children: /* @__PURE__ */ o.jsx(
  "iframe",
  {
    style: { border: "none" },
    width: "100%",
    height: "100%",
    src: `https://www.figma.com/embed?embed_host=share&url=${a}`,
    allowFullScreen: !0
  }
) }), Ur = ({ excalidrawId: a }) => /* @__PURE__ */ o.jsx(P, { height: 380, children: /* @__PURE__ */ o.jsx(
  "iframe",
  {
    title: "Excalidraw",
    width: "100%",
    height: "100%",
    src: `https://excalidraw.com/${a}/embed`,
    frameBorder: "0"
  }
) }), Wr = ({ loomId: a }) => /* @__PURE__ */ o.jsx(P, { height: 380, children: /* @__PURE__ */ o.jsx(
  "iframe",
  {
    title: "Loom",
    width: "100%",
    height: "100%",
    src: `https://www.loom.com/embed/${a}`,
    frameBorder: "0"
  }
) }), qr = ({ dropboxId: a }) => /* @__PURE__ */ o.jsx(P, { height: 380, children: /* @__PURE__ */ o.jsx(
  "iframe",
  {
    title: "Dropbox",
    width: "100%",
    height: "100%",
    src: `https://www.dropbox.com/s/${a}?raw=1`,
    frameBorder: "0"
  }
) }), Br = ({ url: a, title: h = "" }) => {
  const f = ze(null);
  return K(() => {
    if (!f.current)
      return;
    const c = document.createElement("script");
    c.src = "https://platform.twitter.com/widgets.js", c.async = !0, f.current.before(c), c.onload = () => {
      window != null && window.twttr && window.twttr.events.bind("rendered", () => {
        if (f.current) {
          const g = f.current.parentElement;
          g && (g.style.height = "auto", g.classList.add("d-flex", "justify-content-center")), f.current.remove();
        }
      });
    };
  }, []), /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx("blockquote", { className: "twitter-tweet ", children: /* @__PURE__ */ o.jsx("a", { href: a, target: "_blank", children: h }) }),
    /* @__PURE__ */ o.jsx(
      "span",
      {
        ref: f,
        className: "loading position-absolute top-0 left-0 w-100 h-100 z-1 bg-white d-flex justify-content-center align-items-center",
        children: /* @__PURE__ */ o.jsx(Ue, { animation: "border", variant: "secondary" })
      }
    )
  ] });
}, We = (a) => {
  const [h, f] = J(null), g = [
    {
      name: "YouTube",
      regexs: [
        /https:\/\/youtu\.be\/([a-zA-Z0-9_-]{11})/,
        /https:\/\/www\.youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})/,
        /https:\/\/www\.youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/
      ],
      embed: (n) => /* @__PURE__ */ o.jsx(Mr, { videoId: n })
    },
    {
      name: "Twitter",
      regexs: [
        /https:\/\/twitter\.com\/[a-zA-Z0-9_]+\/status\/([a-zA-Z0-9_]+)/,
        /https:\/\/x\.com\/[a-zA-Z0-9_]+\/status\/([a-zA-Z0-9_]+)/
      ],
      embed: (n, p, d = "") => {
        const y = document.createElement("blockquote");
        y.classList.add("twitter-tweet");
        const v = document.createElement("a");
        v.href = p.replace("x.com", "twitter.com"), v.textContent = d, y.appendChild(v);
        const C = document.createElement("script");
        C.src = "https://platform.twitter.com/widgets.js", C.async = !0;
        const k = document.createElement("style");
        return k.innerHTML = `
          .twitter-tweet {
            display: block;
            margin: 0 auto;
          }
        `, /* @__PURE__ */ o.jsx(
          Br,
          {
            url: p.replace("x.com", "twitter.com"),
            title: d
          }
        );
      }
    },
    {
      name: "CodePen",
      regexs: [
        /https:\/\/codepen\.io\/[a-zA-Z0-9_]+\/pen\/([a-zA-Z0-9_]+)/,
        /https:\/\/codepen\.io\/[a-zA-Z0-9_]+\/full\/([a-zA-Z0-9_]+)/
      ],
      embed: (n) => /* @__PURE__ */ o.jsx(zr, { penId: n })
    },
    {
      name: "JSFiddle",
      regexs: [
        /https:\/\/jsfiddle\.net\/[a-zA-Z0-9_]+\/([a-zA-Z0-9_]+)/,
        /https:\/\/jsfiddle\.net\/[a-zA-Z0-9_]+\/([a-zA-Z0-9_]+)\/embed/
      ],
      embed: (n) => /* @__PURE__ */ o.jsx(Zr, { fiddleId: n })
    },
    {
      name: "GithubGist",
      regexs: [
        /https:\/\/gist\.github\.com\/[a-zA-Z0-9_]+\/([a-zA-Z0-9_]+)/,
        /https:\/\/gist\.github\.com\/[a-zA-Z0-9_]+\/([a-zA-Z0-9_]+)\.js/
      ],
      embed: (n, p) => {
        const d = p.indexOf(".js") > -1 ? p : `${p}.js`;
        return /* @__PURE__ */ o.jsx(Nr, { scriptUrl: d });
      }
    },
    {
      name: "Figma",
      regexs: [
        /https:\/\/www\.figma\.com\/design\/[a-zA-Z0-9_]+\/([a-zA-Z0-9_]+)/,
        /https:\/\/www\.figma\.com\/file\/[a-zA-Z0-9_]+\/([a-zA-Z0-9_]+)/
      ],
      embed: (n, p) => /* @__PURE__ */ o.jsx(Yr, { url: p })
    },
    {
      name: "Excalidraw",
      regexs: [
        /https:\/\/excalidraw\.com\/#json=([a-zA-Z0-9_,-]+)/,
        /https:\/\/excalidraw\.com\/([a-zA-Z0-9_,-]+)/
      ],
      embed: (n) => /* @__PURE__ */ o.jsx(Ur, { excalidrawId: n })
    },
    {
      name: "Loom",
      regexs: [
        /https:\/\/www\.loom\.com\/embed\/([a-zA-Z0-9_]+)/,
        /https:\/\/www\.loom\.com\/share\/([a-zA-Z0-9_]+)/
      ],
      embed: (n) => /* @__PURE__ */ o.jsx(Wr, { loomId: n })
    },
    {
      name: "Dropbox",
      regexs: [
        /https:\/\/www\.dropbox\.com\/s\/([a-zA-Z0-9_]+)\/[a-zA-Z0-9_]+/
      ],
      embed: (n) => /* @__PURE__ */ o.jsx(qr, { dropboxId: n })
    }
  ].filter((n) => h == null ? void 0 : h.find(
    (d) => d.platform === n.name && d.enable
  )), s = (n, p) => {
    let d = "";
    return g.forEach((y) => {
      d || y.regexs.forEach((v) => {
        if (d)
          return;
        const C = n.match(v);
        C && (d = y.embed(C[1], n, p));
      });
    }), d;
  }, E = (n) => {
    if (!a)
      return;
    const p = n.querySelectorAll("a");
    let d = !1;
    p.forEach((v) => {
      const C = v.getAttribute("href") || "", k = v.getAttribute("title") || "";
      if (!C || k !== "@embed")
        return;
      const U = s(C, (v == null ? void 0 : v.textContent) || "");
      if (Cr(U)) {
        const L = v.parentElement;
        L.classList.add("position-relative"), L.style.height = "128px", le(L).render(U);
      } else
        d = !0, v.innerHTML = `
          <div class="card embed-light">
            <div class="card-body">
              <div class="text-secondary small mb-1">${C}</div>
              <div class="text-body fw-bold">${v.textContent}</div>
            </div>
          </div>
        `;
    });
    let y = document.querySelector("style#embed-style");
    y || (y = document.createElement("style"), y.id = "embed-style", d && (y.textContent = `
         .embed-light:hover {
           --bs-bg-opacity: 1;
           background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
         }
        `, document.querySelector("head").appendChild(y)));
  }, _ = () => {
    fetch("/answer/api/v1/embed/config").then((n) => n.json()).then((n) => f(n.data));
  };
  K(() => (_(), () => {
    const n = document.querySelector("style#embed-style"), p = document.querySelector("head");
    n && p.removeChild(n);
  }), []), K(() => {
    if (!a || !h)
      return;
    let n;
    a instanceof HTMLElement ? n = a : n = a.current, E(n);
    const p = new MutationObserver(() => {
      E(n);
    });
    return p.observe(n, {
      childList: !0
    }), () => {
      p.disconnect();
    };
  }, [a, h]);
}, Vr = ({ editor: a, previewElement: h }) => {
  const [f, c] = J(!1), { t: g } = Me("plugin", {
    keyPrefix: "basic_embed.frontend"
  });
  We(h), K(() => {
    a && a.addKeyMap({
      "Ctrl-m": s
    });
  }, [a]);
  const s = () => {
    c(!0);
  }, E = ({ title: _, url: n }) => {
    c(!1), a.getCursor().ch !== 0 && a.replaceSelection(`
`);
    const d = `
[${_}](${n} "@embed")
`;
    a.replaceSelection(d), a.focus();
  };
  return /* @__PURE__ */ o.jsxs("div", { className: "toolbar-item-wrap", children: [
    /* @__PURE__ */ o.jsx(
      ie,
      {
        variant: "link",
        className: "p-0 b-0 btn-no-border toolbar text-body",
        onClick: s,
        title: `${g("label")} (Ctrl+m)`,
        children: /* @__PURE__ */ o.jsx("i", { className: "bi bi-window" })
      }
    ),
    /* @__PURE__ */ o.jsx(
      Pr,
      {
        show: f,
        setShowState: c,
        onConfirm: E
      }
    )
  ] });
}, Gr = { plugin: { basic_embed: {
  backend: {
    info: {
      name: { other: "Embed" },
      description: { other: "Embed content from other sites" }
    },
    config: {
      embeds: {
        title: { other: "Supported embeds" },
        description: { other: "Embed rich content such as Tweets, YouTube videos, etc." }
      },
      options: {
        codepen: { other: "CodePen" },
        dropbox: { other: "Dropbox" },
        excalidraw: { other: "Excalidraw" },
        figma: { other: "Figma" },
        githubgist: { other: "GitHub Gist" },
        jsfiddle: { other: "JSFiddle" },
        loom: { other: "Loom" },
        twitter: { other: "X(Twitter)" },
        youtube: { other: "YouTube" }
      }
    }
  },
  frontend: {
    header: "Add Embed",
    title: "Title",
    url: "URL",
    cancel: "Cancel",
    add: "Add",
    required_title: "Title is required",
    required_url: "URL is required",
    invalid_url: "Invalid URL",
    label: "Embed"
  }
} } }, Hr = { plugin: { basic_embed: {
  backend: {
    info: {
      name: { other: "内容嵌入" },
      description: { other: "在内容中嵌入其他网站" }
    },
    config: {
      embeds: {
        title: { other: "支持的嵌入" },
        description: { other: "嵌入富文本，例如： Tweets，YouTube 视频等等" }
      },
      options: {
        codepen: { other: "CodePen" },
        dropbox: { other: "Dropbox" },
        excalidraw: { other: "Excalidraw" },
        figma: { other: "Figma" },
        githubgist: { other: "GitHub Gist" },
        jsfiddle: { other: "JSFiddle" },
        loom: { other: "Loom" },
        twitter: { other: "X(Twitter)" },
        youtube: { other: "YouTube" }
      }
    }
  },
  frontend: {
    header: "添加嵌入",
    title: "标题",
    url: "URL",
    cancel: "取消",
    add: "添加",
    required_title: "标题是必需的",
    required_url: "URL 是必需的",
    invalid_url: "无效的 URL",
    label: "嵌入"
  }
} } }, Jr = {
  en_US: Gr,
  zh_CN: Hr
}, $e = {
  slug_name: "basic_embed",
  type: "editor",
  version: "1.0.4",
  author: "answerdev",
  link: "https://github.com/apache/incubator-answer-plugins/tree/main/embed-basic"
}, rt = {
  info: {
    slug_name: $e.slug_name,
    type: $e.type
  },
  component: Vr,
  i18nConfig: Jr,
  hooks: {
    useRender: [We]
  }
};
export {
  rt as default
};
